import { jwtDecode } from "jwt-decode";

export const checkTokenExpiration = () => {
    const localStorageToken = localStorage.getItem("token");
    if (localStorageToken) {
      const decoded = jwtDecode(localStorageToken);
      const now = new Date().getTime() / 1000;
      
      if (now > decoded.exp) {
        localStorage.clear();
        return false;
      }
      return true;
    }
    return false;
  };